export type GalleryItem = {
  type: "image" | "video";
  src: string;
};

export type EventStatus = "proximo" | "destacado" | "pasado";

export type LabEvent = {
  id: number;
  status: EventStatus;
  titleKey: string;
  titleText: string;
  descriptionKey: string;
  descriptionText: string;
  date: string;
  location?: string;
  imageSrc: string;
  gallery?: GalleryItem[];
  categoryKey?: string;
};

export const events: LabEvent[] = [
  // === DESTACADO ===
  {
    id: 1, status: "destacado",
    titleKey: "event1_title", titleText: "Workshop de Diseño VLSI con FPGA",
    descriptionKey: "event1_desc", descriptionText: "",
    date: "2026-08-15", location: "Laboratorio de Robótica e Industria 4.0, UADY",
    imageSrc: "./img/researchLines/Curso.jpg", categoryKey: "cat_workshop",
  },

  // === PRÓXIMOS ===
  {
    id: 2, status: "proximo",
    titleKey: "event2_title", titleText: "Conferencia: IA en Sistemas Embebidos",
    descriptionKey: "event2_desc", descriptionText: "",
    date: "2026-09-10", location: "Auditorio Facultad de Ingeniería, UADY",
    imageSrc: "./img/researchLines/Curso2.jpg", categoryKey: "cat_conferencia",
  },

  // === PASADOS (orden desc por fecha) ===
  {
    id: 10, status: "pasado",
    titleKey: "event10_title", titleText: "Clausura Maya on Chip — Generación 2026",
    descriptionKey: "event10_desc", descriptionText: "",
    date: "2026-05-29", location: "UADY, Mérida, Yucatán",
    imageSrc: "./img/researchLines/MayanOnChip/clausura2026/27.jpg", categoryKey: "cat_clausura",
    gallery: [
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/1.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/2.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/3.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/4.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/5.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/6.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/7.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/8.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/9.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/10.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/11.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/12.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/13.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/14.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/15.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/16.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/17.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/18.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/19.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/20.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/21.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/22.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/23.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/24.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/25.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/26.jpg" },
    ],
  },
  {
    id: 5, status: "pasado",
    titleKey: "event5_title", titleText: "Intercambio académico COE Texas A&M 2026",
    descriptionKey: "event5_desc", descriptionText: "",
    date: "2026-05-20", location: "Texas A&M University, EUA",
    imageSrc: "./img/researchLines/Texas/2.jpg", categoryKey: "cat_intercambio",
    gallery: [{ type: "image", src: "./img/researchLines/Texas/1.jpg" }],
  },
  {
    id: 9, status: "pasado",
    titleKey: "event9_title", titleText: "Firma de convenio UADY–SETY para Maya on Chip",
    descriptionKey: "event9_desc", descriptionText: "",
    date: "2026-04-19", location: "Auditorio Manuel Cepeda Peraza, Centro Cultural Universitario, UADY",
    imageSrc: "./img/researchLines/MayanOnChip/Convenio.jpg", categoryKey: "cat_convenio",
    gallery: [
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/1.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/2.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/3.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/4.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/5.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/6.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/7.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/8.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/9.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/10.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/11.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/12.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/13.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/14.jpg" },
    ],
  },
  {
    id: 8, status: "pasado",
    titleKey: "event8_title", titleText: "Visita del Rector al proyecto Maya on Chip",
    descriptionKey: "event8_desc", descriptionText: "",
    date: "2026-03-28", location: "Laboratorio de Robótica e Industria 4.0, UADY",
    imageSrc: "./img/researchLines/MayanOnChip/clausura2025/14.jpg", categoryKey: "cat_visita",
    gallery: [
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/10.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/11.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/12.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/13.jpg" },
    ],
  },
  {
    id: 7, status: "pasado",
    titleKey: "event7_title", titleText: "Clausura Maya on Chip — Generación 2025",
    descriptionKey: "event7_desc", descriptionText: "",
    date: "2025-12-14", location: "UADY, Mérida, Yucatán",
    imageSrc: "./img/researchLines/MayanOnChip/clausura2025/4.jpg", categoryKey: "cat_clausura",
    gallery: [
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/1.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/2.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/3.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/4.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/5.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/6.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/7.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/8.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2025/9.jpg" },
    ],
  },
  {
    id: 11, status: "pasado",
    titleKey: "event11_title", titleText: "Inauguración cursos Maya on Chip 2025",
    descriptionKey: "event11_desc", descriptionText: "",
    date: "2025-09-24", location: "Facultad de Ingeniería, UADY",
    imageSrc: "./img/researchLines/MayanOnChip/clausura2025/1.jpg", categoryKey: "cat_inauguracion",
  },
  {
    id: 12, status: "pasado",
    titleKey: "event12_title", titleText: "Firma de convenio Francia–México: Doble Titulación de Doctorado",
    descriptionKey: "event12_desc", descriptionText: "",
    date: "2025-09-01", location: "UADY / Université Clermont Auvergne, Francia",
    imageSrc: "./img/events/convenio.png", categoryKey: "cat_convenio",
  },
  {
    id: 4, status: "pasado",
    titleKey: "event4_title", titleText: "Intercambio académico COE Texas A&M 2025",
    descriptionKey: "event4_desc", descriptionText: "",
    date: "2025-05-15", location: "Texas A&M University, EUA",
    imageSrc: "./img/researchLines/Texas/3.jpg", categoryKey: "cat_intercambio",
  },
  {
    id: 3, status: "pasado",
    titleKey: "event3_title", titleText: "Visita rector UADY: Impulso tecnológico INTEL",
    descriptionKey: "event3_desc", descriptionText: "",
    date: "2024-12-18", location: "Facultad de Ingeniería, UADY",
    imageSrc: "./img/events/intel2024/1.jpg", categoryKey: "cat_visita",
    gallery: [
      { type: "image", src: "./img/events/intel2024/1.jpg" },
      { type: "image", src: "./img/events/intel2024/2.jpg" },
      { type: "image", src: "./img/events/intel2024/3.jpg" },
      { type: "image", src: "./img/events/intel2024/4.jpg" },
      { type: "image", src: "./img/events/intel2024/5.jpg" },
      { type: "image", src: "./img/events/intel2024/6.jpg" },
      { type: "image", src: "./img/events/intel2024/7.jpg" },
    ],
  },
];